import { EditPencil, Lock, LogOut, SmartphoneDevice } from 'iconoir-react';
import { FC, ReactNode } from 'react';

import { BrandMenuItem } from './BrandMenuItem';
import { SubmenuPanel } from './SubmenuPanel';

import i18n from '~/common/helpers/i18n';

export interface ProfileSubmenuProps {
  isMainRealm: boolean;
  onEditProfile: () => void;
  onChangePassword: () => void;
  onTwoFactor: () => void;
  onSignOut: () => void;
}

type ProfileMenuItem = {
  testId: string;
  icon: ReactNode;
  label: ReactNode;
  onPress: () => void;
  hidden?: boolean;
};

export const ProfileSubmenu: FC<ProfileSubmenuProps> = ({
  isMainRealm,
  onEditProfile,
  onChangePassword,
  onTwoFactor,
  onSignOut
}) => {
  const items: ProfileMenuItem[] = [
    {
      testId: 'profile-edit-button',
      icon: <EditPencil className='icon-smallest shrink-0' />,
      label: i18n.t('scenes.profile.labels.edit_profile_details'),
      onPress: onEditProfile
    },
    {
      testId: 'profile-change-password-button',
      icon: <Lock className='icon-smallest shrink-0' />,
      label: i18n.t('scenes.profile.labels.change_password'),
      onPress: onChangePassword,
      hidden: !isMainRealm
    },
    {
      testId: 'profile-two-factor-auth-button',
      icon: <SmartphoneDevice className='icon-smallest shrink-0' />,
      label: i18n.t('scenes.profile.labels.two_factor'),
      onPress: onTwoFactor,
      hidden: !isMainRealm
    },
    {
      testId: 'profile-exit-button',
      icon: <LogOut className='icon-smallest shrink-0' />,
      label: i18n.t('scenes.profile.labels.sign_out'),
      onPress: onSignOut
    }
  ];

  return (
    <SubmenuPanel>
      {items
        .filter(item => !item.hidden)
        .map(item => (
          <BrandMenuItem
            key={item.testId}
            data-testid={item.testId}
            icon={item.icon}
            label={item.label}
            onPress={item.onPress}
          />
        ))}
    </SubmenuPanel>
  );
};
